import React from 'react';
import { Link } from 'react-router-dom';

function FiturOrtuCard({ icon, link, name }) {
  return (
    <div className="w-100 px-3" style={{ paddingTop: 40 }}>
      <div className="iq-card iq-card-block iq-card-stretch iq-card-height">
        <div className="iq-card-body">
          <div className="iq-badges text-center">
            <div className="badges-icon">
              <img className="avatar-80 rounded" src={icon} alt="" />
            </div>
            <Link to={link} className="btn iq-bg-primary d-block">
              {name}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FiturOrtuCard;
